<template>
  <el-card class="h-full ys-monitor-wrapper" :body-style="{ height: '100%' }">
    <div
      class="w-full mb-10px"
      :class="isShowPagination ? 'h-[calc(100%-75px)]' : 'h-[calc(100%-40px)]'"
    >
      <!-- 一、四、九宫格 -->
      <div class="flex w-full h-full flex-wrap justify-around items-center">
        <div
          :key="index"
          @click="setCurVideoIndex(index)"
          v-for="(item, index) in monitorList"
          class="grid-item p-2px default-grid-item"
          :class="[{ 'select-grid-item': curPlayIndex === index }]"
          :style="computedGridItemStyle"
        >
          <div class="h-full w-full" v-if="item.code">
            <NewYSPlayer :code="item.code" :name="item.name" :pIid="item.pIid"></NewYSPlayer>
          </div>
          <MonitorEmpty v-else></MonitorEmpty>
        </div>
      </div>
    </div>

    <!-- 底部工具栏 -->
    <div class="bottom-btns flex justify-center items-center h-30px leading-30px">
      <div
        class="icon-item"
        v-for="(item, index) in iconList"
        :key="index"
        @click="gridShowHandle(item.showCameraNumber)"
      >
        <img
          v-if="monitorNum === item.showCameraNumber"
          :src="require(`@/assets/images/video-monitor/${item.activeIcon}.png`)"
        />
        <img v-else :src="require(`@/assets/images/video-monitor/${item.defaultIcon}.png`)" />
      </div>
    </div>

    <!-- 底部分页器 -->
    <el-pagination
      v-if="isShowPagination"
      background
      @size-change="findList()"
      @current-change="findList()"
      :current-page.sync="pageIndex"
      :page-size.sync="monitorNum"
      :page-sizes="[10, 15, 20, 30, 50, 100]"
      layout="total, prev, pager, next"
      :total="defaultMonitorList.length"
      class="mt-10px text-center"
    ></el-pagination>
  </el-card>
</template>

<script>
import NewYSPlayer from '@/components/video/YSPlayer/NewYSPlayer'
import MonitorEmpty from './MonitorEmpty'

export default {
  name: 'ysMonitor',
  components: {
    MonitorEmpty,
    NewYSPlayer,
  },
  props: {
    defaultMonitorList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      monitorNum: 1,
      isFullScreen: false,
      curPlayIndex: 0,
      monitorList: [{}],
      iconList: [
        // 0 代表当前激活项全屏
        // {
        //   showCameraNumber: 0,
        //   defaultIcon: 'max',
        //   activeIcon: 'max-select',
        // },
        {
          showCameraNumber: 1,
          defaultIcon: 'ys-one-grid',
          activeIcon: 'ys-one-grid-select',
        },
        {
          showCameraNumber: 4,
          defaultIcon: 'ys-four-grid',
          activeIcon: 'ys-four-grid-select',
        },
        {
          showCameraNumber: 9,
          defaultIcon: 'ys-nine-grid',
          activeIcon: 'ys-nine-grid-select',
        },
        {
          showCameraNumber: 16,
          defaultIcon: 'ys-sixteen-grid',
          activeIcon: 'ys-sixteen-grid-select',
        },
      ],
      pageIndex: 1,
    }
  },
  methods: {
    gridShowHandle(gridNumber) {
      this.pageIndex = 1 // 重置分页器
      this.monitorNum = gridNumber // 记录当前激活
      this.monitorList = _.flow(
        (list) => {
          return _.take(list, gridNumber)
        },
        (items) => {
          return _.concat(items, _.times(Math.max(0, gridNumber - items.length), _.constant({})))
        }
      )(this.defaultMonitorList)
    },

    setCurVideoIndex(index) {
      this.curPlayIndex = index
    },

    playVideo(info) {
      this.$set(this.monitorList, this.curPlayIndex, info)
    },

    findList() {
      const startIndex = (this.pageIndex - 1) * this.monitorNum
      const endIndex = this.pageIndex * this.monitorNum

      const currentItems = _.slice(this.defaultMonitorList, startIndex, endIndex)
      const fillCount = Math.max(0, this.monitorNum - currentItems.length)

      this.monitorList = _.concat(
        currentItems,
        _.times(fillCount, () => {
          return {}
        })
      )
    },
  },
  computed: {
    computedGridItemStyle() {
      return {
        width: `calc(${100 / Math.sqrt(this.monitorNum)}% - 5px)`,
        height: `calc(${100 / Math.sqrt(this.monitorNum)}% - 5px)`,
      }
    },
    // 是否在icon底部显示分页器
    isShowPagination() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config')
          ?.NewYSPlayerConfig?.isShowPagination || false
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.ys-monitor-wrapper {
  .select-grid-item {
    border: 5px solid var(--systemMainColor) !important;
  }

  .default-grid-item {
    background: var(--collapseHeadHeaderBg);
    border: 1px solid transparent;
  }

  .bottom-btns {
    display: flex;
    justify-content: center;
    align-items: center;

    .icon-item {
      width: 35px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
